import React, { Component } from "react";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import { Navigate } from "react-router-dom";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import moment from "moment";
import { encryptAES } from "../../utils/Encryption";
import ValidationText from "../../utils/validation/ValidationText";
import DropdownSelect from "../../components/dropdown/Dropdown";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import EntryManagementServices from "../../services/axiosServices/apiServices/EntryManagementServices";
import DateRangePicker from 'react-daterange-picker';

export default class BookingCancellation extends Component {
  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices();
    this.entryServices = new EntryManagementServices();
    this.picker = React.createRef();
    this.state = {
      dateRange: [new Date(), new Date()], // default: today → today
      selectedRange: null,
      isPickerOpen: false, // Tracks picker visibility
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        // dateFrom:moment().startOf('month').format('YYYY-MM-DD'),
        // dateTo:moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: "",
        dateTo: "",
        statusId: null
      },
      actionDropdown: ["Detail"],
      route: "",
      totalResultes: "",
      bookingCancellationList: [],
      isLoading: false,
      rejectStatusList: [],
      pickerStyle: {
        display: 'inline-block',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        borderRadius: '4px'
      },
    };
  }
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getbookingsCancellationRequestList(newPagination);
  };

  getbookingsCancellationRequestList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.BookingServices.getbookingsCancellationRequestList(pagination).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent.itemList;
          details.map((key, index) => {
            key.requestDate = moment(key.requestDate).format("DD MMM YYYY");
          }); this.setState({ bookingCancellationList: details });
          this.setState({
            totalResultes: response.responseItem.responseContent.totalCount,
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  actionClick = (index, value, option, event) => {
    if (option === "Detail") {
      if (value && value > 0) {
        this.setState({
          route:
            "/booking/NewBookingCancellationDetail/cancellationId?=" +
            encryptAES(value),
        });
      }
    }
  };
  actions = (element, index, value) => {
    return element !== "CancellationId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdown}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };
  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    // this.getbookingsCancellationList();
  };

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getbookingsCancellationRequestList();
      } else if (fulldate === null) {
        this.getbookingsCancellationRequestList();
      }
    });
  }

  getAllDropDownForEntryManagement = () => {
    this.entryServices.getAllDropDownForEntryManagement(0).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let rejectStatus = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "RejectStatusDropDown");
        rejectStatus = rejectStatus.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        this.setState({ rejectStatusList: rejectStatus });
      }
    });
  };

  handleSelect = (range) => {
    if (range && range.startDate && range.endDate) {
      this.setState({ selectedRange: range, isPickerOpen: false });
    } else {
      console.log('Incomplete range selected:', range);
    }
  };

  handleChangeInDropdown = (selected, drpIdentity) => {
    if (drpIdentity === "status") {
      let detail = this.state.pagination;
      detail.statusId = selected != null && selected.value != 0 ? selected.value : null;
      detail.pageNo = 1;
      this.setState({ pagination: { ...detail } });
      this.getbookingsCancellationRequestList();
    }
  };

  // Callback when a date range is selected
  handleSelect = (range) => {
    this.setState({
      selectedRange: range,
      pagination: {
        ...this.state.pagination,
        dateFrom: moment(range.start.toDate()).format('YYYY-MM-DD'),
        dateTo: moment(range.end.toDate()).format('YYYY-MM-DD')

      },
      isPickerOpen: false, // Close picker after selection
    });
  };

  togglePicker = () => {
    this.setState((prevState) => ({
      isPickerOpen: !prevState.isPickerOpen,
    }));
  };

  handleClickOutside = (event) => {
    if (this.pickerRef && this.pickerRef.current && !this.pickerRef.current.contains(event.target)) {
      this.setState({ isPickerOpen: false });
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  componentDidMount() {
    this.getbookingsCancellationRequestList();
    this.getAllDropDownForEntryManagement();
  }

  render() {
    if (this.state.route != "") {
      return <Navigate to={this.state.route} />;

    }

    const { selectedRange, isPickerOpen } = this.state;
    const initialDate = moment(); // Today's date as initial view
    return (
      <div className="main-body-section View-booking-sec">
        <div className="custom-card">

          <div className="filter-info grid grid-cols-12 gap-6">
            <div className="filter-types xl:col-span-4 lg:col-span-4 col-span-12">
              <label
                className="theme-label"
                htmlFor="default"
              >
                Event Name
              </label>
              <input
                id="tagName"
                name="tagName"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                // value={this.state.pagination.searchText}
                onChange={(event) => this.searchByName(event.target.value)}
              //   onBlur={() => this.validateField("tagName")}
              />
              {/* <ValidationText error={this.state.validState.error.tagName} /> */}
            </div>
            {/* <div className="filter-types xl:col-span-4 lg:col-span-4 col-span-12">
            <label
              className=" theme-label"
              htmlFor="default"
            >
              Type
            </label>
            <input
              id="tagName"
              name="tagName"
              className="form-input rounded-none w-full shadow-red py-3 text-lg"
              type="text"
            //   value={this.state.addTagdetails.tagName}
              onChange={(event) => this.searchByName(event.target.value)}
            //   onBlur={() => this.validateField("tagName")}
            />
            {/* <ValidationText error={this.state.validState.error.tagName} /> 
          </div> */}
            <div className="filter-types xl:col-span-4 lg:col-span-4 col-span-12">
              <label
                className=" theme-label"
                htmlFor="default"
              >
                Status
              </label>
              <Selector
                options={this.state.rejectStatusList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={this.handleChangeInDropdown.bind(this)}
                allowSelectAll={false}
                // value={this.state.hiddenOption.find(
                //   (x) => x.label === this.state.pagination.hiddenSearch
                // )}
                drpIdentity="status"
              />
              {/* <ValidationText error={this.state.validState.error.tagName} /> */}
            </div>
          </div>
          <div className="top-filter-sec mt-4">
            <div className="theme-label">Event Book Date</div>
            <div className="flex justify-between pb-7">
              <div className="left-date">
                <div className="grid grid-cols-12 gap-6 items-center w-full">
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    {/* <input
                    id="default"
                    name="dateFrom"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateFrom}
                    onChange={(e) => this.handleChange(e)}
                  /> */}
                    <div style={this.state.pickerStyle}>
                      <div>
                        <input
                          type="text"
                          readOnly
                          value={
                            this.state.pagination.dateTo
                              ? `${moment(this.state.pagination.dateFrom).format('DD-MM-YYYY')} - ${moment(this.state.pagination.dateTo).format('DD-MM-YYYY')}`
                              : 'Select a date range'
                          }
                          onClick={this.togglePicker}
                          style={{
                            padding: '8px',
                            width: '200px',
                            cursor: 'pointer',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                          }}
                        />
                      </div>

                      {/* Conditionally render DateRangePicker */}
                      {isPickerOpen && (
                        <div
                          ref={this.pickerRef}
                          style={{
                            position: 'absolute',
                            zIndex: 1000,
                            background: 'white',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                          }}
                        >
                          <DateRangePicker
                            initialDate={initialDate}
                            // onInit={this.handleInit}
                            onSelect={this.handleSelect}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <div className=" 2xl:col-span-2 lg:col-span-2 col-span-12 w-full text-center">
                  <h2 className="text-xl theme-color">To</h2>
                </div> */}
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    {/* <input
                    id="default"
                    name="dateTo"
                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                    type="date"
                    value={this.state.pagination.dateTo}
                    onChange={(e) => this.handleChange(e)}
                  /> */}
                  </div>
                </div>
              </div>
              <div className="right-search flex items-center">
                <button
                  className="col-end-8 col-span-1 btn  btn-red "
                  // value={this.state.pagination.searchText}
                  onClick={() => this.getbookingsCancellationRequestList()}
                >
                  Search
                </button>
              </div>
            </div>
            <Table
              columns={[
                { name: "BookingReferenceNo", title: "Ref. No." },
                { name: "ClassName", title: "Event Name" },
                { name: "RequestDate", title: "Event Book Date" },
                { name: "AttendeeName", title: "Attendee Name" },
                { name: "IsRequestFor", title: "Request Type" },
                { name: "BookingStatus", title: "Status" },
                { name: "CancellationId", title: "Actions" },
              ]}
              rows={this.state.bookingCancellationList}
              isLoading={this.state.isLoading}
              sortingColumns={["BookingReferenceNo"]}
              pagination={this.state.pagination}
              totalResultes={this.state.totalResultes}
              totalCount={this.state.totalResultes}
              setPagination={this.setPagination.bind(this)}
              customScope={[
                {
                  column: "CancellationId",
                  renderTableData: this.actions.bind(this),
                },
                // {
                //     column: "selectRow",
                //     renderTableData: this.select.bind(this),
                //     valueColumnName: "chartsOfAccountsId",
                // },
              ]}
            />
          </div>
        </div>

      </div>
    );
  }
}
